/**
 * Utilitários para busca fuzzy
 * Remove acentos, pontuação e espaços para correspondência mais flexível
 */

/**
 * Mapa de caracteres acentuados para não-acentuados
 */
const accentsMap: Record<string, string> = {
  // Minúsculas
  'á': 'a', 'à': 'a', 'ã': 'a', 'â': 'a', 'ä': 'a',
  'é': 'e', 'è': 'e', 'ê': 'e', 'ë': 'e',
  'í': 'i', 'ì': 'i', 'î': 'i', 'ï': 'i',
  'ó': 'o', 'ò': 'o', 'õ': 'o', 'ô': 'o', 'ö': 'o',
  'ú': 'u', 'ù': 'u', 'û': 'u', 'ü': 'u',
  'ç': 'c', 'ñ': 'n',
  // Maiúsculas
  'Á': 'a', 'À': 'a', 'Ã': 'a', 'Â': 'a', 'Ä': 'a',
  'É': 'e', 'È': 'e', 'Ê': 'e', 'Ë': 'e',
  'Í': 'i', 'Ì': 'i', 'Î': 'i', 'Ï': 'i',
  'Ó': 'o', 'Ò': 'o', 'Õ': 'o', 'Ô': 'o', 'Ö': 'o',
  'Ú': 'u', 'Ù': 'u', 'Û': 'u', 'Ü': 'u',
  'Ç': 'c', 'Ñ': 'n',
};

/**
 * Normaliza texto para busca fuzzy
 * Remove acentos, pontuação e espaços, mantendo apenas letras e números
 * 
 * @example
 * normalizeSearchText('José da Silva') // 'josedasilva'
 * normalizeSearchText('55.245.408/0001-15') // '55245408000115'
 * normalizeSearchText('IMPLEMENTOS') // 'implementos'
 */
export function normalizeSearchText(text: string): string {
  if (!text) return '';

  return text
    // A-quattuor.6: decomposição NFD + remoção de diacríticos combinantes ANTES do mapa —
    // cobre qualquer acento (não só os do mapa); o mapa fica como rede para o que não decompõe.
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .split('')
    .map(char => accentsMap[char] || char)
    .join('')
    .replace(/[^a-zA-Z0-9]/g, '')  // Remove pontuação e espaços
    .toLowerCase();
}

/**
 * A-quattuor.6: filtro para `<Command filter={...}>` do cmdk — o default só faz toLowerCase.
 * Casa `value` e `keywords` normalizados (sem acento/caixa/pontuação) contra o termo normalizado.
 * Retorna 1 (mostra) ou 0 (esconde); termo vazio mostra tudo.
 */
export function cmdkNormalizedFilter(value: string, search: string, keywords?: string[]): number {
  const term = normalizeSearchText(search);
  if (!term) return 1;
  return [value, ...(keywords ?? [])].some((k) => normalizeSearchText(k).includes(term)) ? 1 : 0;
}
